import { createRouter, createWebHistory } from 'vue-router';
import {  defaultLocale, withLocale } from "@/locales/localization";

import HomePage from '@/pages/HomePage/HomePage.vue';
import TripsPage from '@/pages/Trip/TripPage.vue';
import TripsList from "@/pages/Trip/TripList.vue";
import LoginPage from "@/pages/LoginPage/LoginPage.vue";
import ResetPassword from "@/pages/ResetPassword/ResetPassword.vue";
import SearchResults from '@/pages/SearchResults/SearchResults.vue';
import MyAccount from '@/pages/Account/Account.vue';
import CrewLists from '@/pages/CrewLists/CrewLists.vue';
import CrewDetails from '@/pages/CrewDetails/CrewDetails.vue';

import Sorry from '@/pages/Sorry/Sorry.vue';
import Thankyou from '@/pages/Thankyou/Thankyou.vue';
import Comparison from '@/pages/Comparison/Comparison.vue';
import SearchResultsOffers from '@/pages/SearchResultsOffers/SearchResultsOffers.vue';
import YachtPage from '@/pages/YachtPage/YachtPage.vue';
import OfferPage from '@/pages/YachtPage/OfferPage.vue';
import Terms from '@/pages/Terms/Terms.vue';
import Privacy from '@/pages/Privacy/Privacy.vue';
import FAQ from '@/pages/FAQ/FAQ.vue';
import Blog from '@/pages/Blog/Blog.vue';
import Itineraries from '@/pages/Itineraries/Itineraries.vue'
import AboutPage from '@/pages/AboutPage/AboutPage.vue';
import WhyBook from '@/pages/WhyBook/WhyBook.vue';
import BookingAssurance from '@/pages/BookingAssurance/BookingAssurance.vue';
import PageView from "@/pages/CMS/PageView.vue";
import Partners from "@/pages/Partners/Partners.vue";
import Help from "@/pages/Help/Help.vue";
import Inquiry from "@/pages/Help/Inquiry.vue";
import Imprint from "@/pages/Imprint/Imprint.vue";
import { fixLocaleInUrl } from "@/locales/localization";
import ItineraryView from "@/pages/CMS/ItineraryView.vue";
import {authGuard} from "@auth0/auth0-vue";
import {auth0} from "@/auth/auth.ts";
import * as AuthService from "@/services/auth.service.ts";
import {useUserStore} from "@/stores/userStore.ts";
import CallbackView from "@/components/CallbackView/CallbackView.vue";
import {useTripsStore} from "@/stores/tripsStore.ts";
import {computed} from "vue";


const routes = [
    { path: '/', redirect: `/${defaultLocale}` },
    withLocale({ path: '/', component: HomePage }),
    withLocale({ path: '/login', name: 'login', component: LoginPage }),
    withLocale({ path: '/register', name: 'register', component: LoginPage }),
    withLocale({ path: '/forgot-password', name: 'forgot-password', component: LoginPage }),
    withLocale({ path: '/reset-password',name: 'reset-password', component: ResetPassword }),
    // withLocale({ path: '/my/trips', component: TripsList }),

    withLocale({
        path: '/my',
        beforeEnter: [authGuard],
        children: [
            { path: 'trips', component: TripsList},
            {path: 'trip/:id',
                component: TripsPage,
                children: [
                    {
                        path: '',
                        name: 'trip-overview',
                        component: () => import('@/components/TripOverview/TripOverview.vue'),
                        beforeEnter: (to) => {
                            const tripStore = useTripsStore();
                            const state = tripStore.trip?.state;
                            if (state !== 'planned' && state !== 'active' && state !== 'done') {
                                return {
                                    name: 'trip-saved-offers',
                                    params: to.params
                                };
                            }
                        }
                    },
                    {
                        path: 'saved-offers',
                        name: 'trip-saved-offers',
                        component: () => import('@/components/TripSavedOffers/TripSavedOffers.vue'),
                        beforeEnter: async (to) => {
                            const tripStore = useTripsStore();
                            const state = tripStore.trip?.state;
                            if (state === 'planned' || state === 'active' || state === 'done') {
                                return {
                                    name: 'trip-overview',
                                    params: to.params
                                };
                            }
                        }
                    },
                    // { path: '', name: 'trip-overview', component: () => import('@/components/TripOverview/TripOverview.vue')},
                    // { path: '', redirect: (to) => ({ name: 'trip-saved-offers', params: to.params }) },//temporary redirect to saved offers
                    // { path: 'saved-offers', name: 'trip-saved-offers', component: () => import('@/components/TripSavedOffers/TripSavedOffers.vue')},
                    // { path: 'itinerary', name: 'trip-itinerary', component: () => import('@/components/TripItenary/TripItenary.vue')},
                    { path: 'crew', name: 'trip-crew', component: () => import('@/components/TripCrew/TripCrew.vue')},
                    { path: 'invoices', name: 'trip-invoices', component: () => import('@/components/TripInvoices/TripInvoices.vue')},
                    //{ path: 'budget', name: 'trip-budget', component: () => import('@/components/TripBudgetOverview/TripBudgetOverview.vue')}
                ]
            },
            { path: 'account', component: MyAccount},
            { path: 'crew-list', component: CrewLists},
            { path: 'crew-list/:id', component: CrewDetails}
        ]
    }),

    withLocale({
        path: '/search',
        component: SearchResults,
        beforeEnter: (to, from, next) => {
            to.params.prevRoute = from.fullPath;
            next();
        }
    }),
    withLocale({
        path: '/callback',
        name: 'callback',
        component: CallbackView
    }),
    withLocale({ path: '/recommendations', component: SearchResultsOffers }),
    withLocale({ path: '/thankyou', component: Thankyou }),
    withLocale({ path: '/terms', component: Terms }),
    withLocale({ path: '/privacy', component: Privacy }),
    withLocale({ path: '/faq', component: FAQ }),
    withLocale({ path: '/page/:slug/:child', component: PageView }),
    withLocale({ path: '/page/itineraries/:slug', component: ItineraryView }),
    withLocale({ path: '/about', component: AboutPage }),
    withLocale({ path: '/blog', component: Blog }),
    withLocale({ path: '/itineraries', component: Itineraries }),
    withLocale({ path: '/why-book', component: WhyBook }),
    withLocale({ path: '/partners/:id', component: Partners }),
    withLocale({ path: '/booking-assurance', component: BookingAssurance }),
    withLocale({ path: '/yachts/compare', component: Comparison }),
    withLocale({
        path: '/:tripUuid/offers/:yachtUuid',
        name: 'YachtFromTrip',
        component: OfferPage,
        meta: { savedOffer: true },
    }),
    withLocale({ 
        path: '/yachts/:id', 
        name: 'YachtPage',
        component: YachtPage,
        meta: { yachtPage: true }
    }),
    withLocale({ path: '/help', component: Help }),
    withLocale({ path: '/inquiry', component: Inquiry }),
    withLocale({ path: '/imprint', component: Imprint }),
    withLocale({ path: '/:pathMatch(.*)*', component: Sorry })
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        // Scroll to anchor if hash is present
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            };
        }

        // Don't scroll if only query changed
        if (to.path === from.path && to.fullPath !== from.fullPath) {
            return false;
        }

        // Default: scroll to top on full route change
        return { top: 0 };
    }
});



router.beforeEach((to, from, next) => fixLocaleInUrl(to, from, next));


export default router;